import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  loader: {
    paddingTop: 200,
    textAlign: "center",
    width: "100%",
  },
}));

export default useStyles;
